import { __ } from '@wordpress/i18n';
import { useEffect, useState, useRef } from 'react';
import { updateMailChimp } from '../../helper/axios';
import SaveButton from './save-button';

const UserData = ({ setSnackbar }) => {
    const [isSave, setIsSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const { userData } = window['JkitDashboardOption'];
    const inputRef = useRef(null);
    const saveOption = async () => {
        if (inputRef.current) {
            await updateMailChimp({ mailchimp_api_key: inputRef.current.value }).then(res => {
                if (res && res.status) {
                    setIsSaved(true);
                    setSnackbar(__('Change Saved', 'jeg-elementor-kit'));
                    window['JkitDashboardOption'].userData.mailchimp.api_key = inputRef.current.value;
                } else {
                    setSnackbar(res.message ? res.message : __('Saved Failed', 'jeg-elementor-kit'));
                }
                setTimeout(() => {
                    setIsSaved(false);
                    setIsSave(false);
                }, 1000);
            })
                .catch((err) => {
                    setSnackbar(err ? err : __('Saved Failed', 'jeg-elementor-kit'));
                });;
        }
    };

    useEffect(() => {
        if (inputRef.current && userData?.mailchimp?.api_key !== undefined) {
            inputRef.current.value = userData.mailchimp.api_key
        }

    }, []);

    return (
        <div className="content-wrapper general">
            <h3>{__('MailChimp API KEY', 'jeg-elementor-kit')}</h3>
            <div className='control-wrapper'>
                <div className='jkit-control jkit-text'>
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="XXX - XXX -XXX"
                        className="control-text"
                    />
                </div>
                <SaveButton isSaved={isSaved} isSave={isSave} onSave={saveOption} />
            </div>
            <span className='option-desc'>Insert your Mailchimp API key. For more info, you can check out this <a href='https://mailchimp.com/help/about-api-keys/#Find_or_generate_your_API_key'>article</a> .</span>
        </div>

    );
};

export default UserData;
